<template>
  <div class="col-12 col-md-6 col-lg-4  mb-4 mb-lg-0">
    <div class="card h-100">
      <div class="card-body">
        <h2 class="heading-card mb-3">{{ section_title }}</h2>
        <div>
          <ul class="row text-sm-start mb-4">
            <li class="col-6 col-md-12 mb-2" v-for="(link, index) in theLinks" v-bind:key="index"><i :class="link.icon"></i><a :href="link.url">{{ link.title }}</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    root: String
  },
  data () {
    return {
      section_title: '',
      theLinks: []
    }
  },

  async created () {
    const { data: jsonData } = await axios.get(this.root + '/library/static/data/quickLinks.json?nocache' + (new Date()).getTime())
    this.section_title = jsonData.quicklinks.title
    this.theLinks = jsonData.quicklinks.links
  }
}
</script>

<style scoped>
  ul {
    margin: 0 0 0 10px;
    padding: 0;
    list-style: none;
  }

  svg {
    display: inline-block;
    width: 40px;
  }
</style>
